var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenuClosed = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C12.7364 0 13.3333 0.596954 13.3333 1.33333V10.6667H22.6667C23.403 10.6667 24 11.2636 24 12C24 12.7364 23.403 13.3333 22.6667 13.3333H13.3333V22.6667C13.3333 23.403 12.7364 24 12 24C11.2636 24 10.6667 23.403 10.6667 22.6667V13.3333H1.33333C0.596954 13.3333 0 12.7364 0 12C0 11.2636 0.596954 10.6667 1.33333 10.6667H10.6667V1.33333C10.6667 0.596954 11.2636 0 12 0Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenuClosed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/menu-closed.72ea7ccd0ffc96767b20a8798776f857.svg";